import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Field, reduxForm, formValueSelector, submit } from 'redux-form/immutable';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import { renderTextField, renderToggle } from '../../../utils/reduxforms';

import AlertDialog from '../../Common/AlertDialog';
import ReduxDialog from '../../Common/ReduxDialog';
import { addAccountFormHandler, fetchStaticRoutine } from '../../../redux/routines';
import { toArray } from '../../../utils/helper';
import { required } from '../../../utils/formvalidation';
import { showError, showDialog, hideDialog } from '../../../redux/actions/dialogs';

import styles from './styles';
import { isDialogVisibleSelector } from '../../../redux/selectors';
import { ADD_ACCOUNT_DIALOG, ALERT_DIALOG } from '../../../redux/constants/dialogs';

class AddAccountDialog extends Component {

  componentWillMount() {
    this.props.fetchIndustries();
  }

  render() {
    const { handleSubmit, submit, isDialogVisible } = this.props;
    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(ADD_ACCOUNT_DIALOG)}
      >Cancel</Button>,
      <Button
        key="submit"
        variant="text"
        color="primary"
        autoFocus
        type="submit"
        onClick={() => submit(ADD_ACCOUNT_DIALOG)}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={ADD_ACCOUNT_DIALOG}
        title="Create Account"
        actions={actions}
        maxWidth="sm"
        fullWidth
      >
        <Paper style={styles.paper}>
          <Form style={styles.form} onSubmit={handleSubmit(addAccountFormHandler)}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <Field
                  name="company"
                  component={renderTextField}
                  type="text"
                  fullWidth
                  label="Company"
                  validate={[required]}
                />
                {/*<Field*/}
                {/*name="industryId"*/}
                {/*component={SelectField}*/}
                {/*style={styles.input}*/}
                {/*fullWidth*/}
                {/*InputLabelProps={{shrink: true}}*/}
                {/*label="Industry"*/}
                {/*validate={[required]}*/}
                {/*>*/}
                {/*{ industries.map((industry) => <MenuItem*/}
                {/*key={industry.id}*/}
                {/*value={industry.id}*/}
                {/*primaryText={industry.name}/>)}*/}
                {/*</Field>*/}
              </Grid>
            </Grid>

            {/*<div style={styles.row}>*/}
            {/*<Field*/}
            {/*name="tacAccepted"*/}
            {/*component={renderToggle}*/}
            {/*label={<span>I accept the <a href="https://staza.io/terms-service.html" rel="noopener noreferrer" target="_blank">terms and conditions</a></span>}*/}
            {/*validate={[required]}*/}
            {/*/>*/}
            {/*</div>*/}
          </Form>
        </Paper>
        {isDialogVisible(ALERT_DIALOG) ? <AlertDialog/> : null}
      </ReduxDialog>
    );
  }
}

AddAccountDialog.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fetchIndustries: PropTypes.func.isRequired,

  showError: PropTypes.func.isRequired,

  tacAccepted: PropTypes.bool,
};

const form = reduxForm({
  form: ADD_ACCOUNT_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(ADD_ACCOUNT_DIALOG);
  },
  onSubmitFail: (errors, dispatch, submitError) => {
    console.log('AddAccount - onSubmitFail', errors);
    if (_.keys(errors).length > 0) {
      dispatch(showError('Account Creation Failed', 'Please complete all mandatory fields'));
    } else {
      dispatch(showError('Account Creation Failed', 'Unknown error'));
    }

  },
})(AddAccountDialog);

function mapStateToProps(state) {
  const selector = formValueSelector(ADD_ACCOUNT_DIALOG);
  return {
    isDialogVisible: isDialogVisibleSelector(state),
    industries: toArray(state.getIn(['static', 'industries']).toJS()),
    tacAccepted: selector(state, 'tacAccepted'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    fetchIndustries: () => fetchStaticRoutine.trigger({ type: 'industries' }),
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Authentication/AddAccountDialog/index.js